export const TRANSITION_DURATION = 300;
export const PADDING_LEVELS = {
  default: {
    left: "0.675rem",
    top: "0.125rem",
    bottom: "0.125rem",
    right: "0.675rem",
  },
  level0: {
    left: "0.75rem",
    top: "0.25rem",
    bottom: "0.125rem",
    right: "0.75rem",
  },
};

export const FONT_SIZES = {
  xl: "text-xl",
  base: "text-base",
  small: "text-[15px]",
};

export const FONT_WEIGHTS = {
  light: "font-light",
  normal: "font-sans",
  medium: "font-[500]",
  semibold: "font-semibold",
  bold: "font-bold",
};
